
import {resetRouter} from '@/router/index'

export default {
    name: 'Tokenlogin',
    data() {
      return {}
    },
    created() {

    },
    mounted() {
      let access_token = this.$route.query.access_token
      let lang_type = this.$route.query.lang_type

      console.log('access_token === ' + access_token)
      console.log('lang_type === ' + lang_type)

      this.tokenLogin(access_token, lang_type)
    },
    methods: {
      tokenLogin(access_token, langType) {
        if (langType == 'CN') {
          this.loginlanguageFlag = 0;
          this.$i18n.locale = 'zh';
        }else{
          this.loginlanguageFlag = 1;
          this.$i18n.locale = 'en';
        }
        sessionStorage.setItem('loginFlag', this.loginlanguageFlag);
        this.$axios.get('/api/sso/tokenlogin', {
          params: {
            "access_token": access_token,
            "lang_type": langType
          }
        })
          .then(response => {
            console.log('超级登录接口数据返回')
            console.log(response.data.data)
            let data = response.data
            if(data.code === 1){
              this.$message({
                message: this.$t('login.message.tokenerror'),
                type: 'warning',
                center: true
              });
              console.log('token失效')
              this.$router.push('/')
              resetRouter();
              return;
            }
            if(data.code === 2){
              this.$message({
                message: this.$t('login.message.usernotexist'),
                type: 'warning',
                center: true
              });
              console.log('未注册')
              this.$router.push('/')
              resetRouter();
              return;
            }
            console.log('验证通过')
            const token = response.data.data.access_token;
            sessionStorage.setItem('token', token);
            // 登录以后获取token中的菜单信息数据源
            // 根据用户获取菜单
            this.$axios.get('/api/accounts/allMenu').then(resAll => {
                sessionStorage.setItem('allMenu', JSON.stringify(resAll.data.resultData));
                this.$axios.get(`/api/accounts/menu`).then((res) => {
                    const systems = res.data.resultData;
                    if (systems && systems.length > 0) {
                        const current = systems[0];
                        // 处理多系统菜单及名称
                        const currentSystem = {
                            zhName: current.systemName,
                            enName: current.systemEnName,
                            routeData: current.menulist,
                            code: current.systemCode
                        };
                        sessionStorage.setItem('currentSystem', JSON.stringify(currentSystem));
                    }
                    if (systems && systems.length > 1) {
                        const other = systems[1];
                        // 处理多系统菜单及名称
                        const otherSystem = {
                            zhName: other.systemName,
                            enName: other.systemEnName,
                            routeData: other.menulist,
                            code: other.systemCode
                        };
                        sessionStorage.setItem('otherSystem', JSON.stringify(otherSystem));
                    }
                    // 根据用户登录的菜单动态处理路由
                    resetRouter(sessionStorage.getItem('allMenu'), sessionStorage.getItem('currentSystem'));
                    this.$router.push('/home');
                }).catch((e) => {
                    console.log(e)
                });
            }).catch(e => {
                console.log(e);
                this.$message({
                    message: this.$t('EM-101'),
                    type: 'error',
                    center: true
                });
            });
          })
          .catch(error => {
            console.log(error);
            //this.abnormalSituation()
          });
      }

    },
    components: {}
  }